import React, { useEffect, useState } from 'react';

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Button,
} from 'reactstrap';
import { toast } from 'react-toastify';
import api from '../../util/api';
import CheckIcon from '../../shared/components/custom/CheckIcon';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';

const SyncMatchControl = () => {
  const [, setSyncMatches] = useState({});
  const [, setTodaysMatches] = useState([]);
  const [controlMatches, setControlMatches] = useState({
    red: [],
    green: [],
    yellow: [],
  });

  const _controlMatches = async (sync, today) => {
    const matchIds = Object.keys(sync)
      .reduce((t, e) => [...t, ...sync[e]], [])
      .map((e) => +e);
    const green = matchIds.filter((mid) => today.find((m) => m.id === mid));
    const yellow = matchIds.filter((mid) => !today.find((m) => m.id === mid));
    const red = today.filter((m) => !matchIds.includes(m.id));
    try {
      const yellowMatches = (
        await Promise.all(yellow.map((y) => api.clubadmin.match.fetch(y)))
      ).map((m) => m.data);
      return {
        red,
        green: today.filter((m) => green.includes(m.id)),
        yellow: yellowMatches,
      };
    } catch (e) {
      return {
        red,
        green: today.filter((m) => green.includes(m.id)),
        yellow: [],
      };
    }
  };

  const fetch = async () => {
    try {
      const { data: _syncMatches } = await api.clubadmin.syncMatch.fetch();
      const { data: _todaysMatchs } = await api.clubadmin.match.todaysMatches();
      setTodaysMatches(_todaysMatchs);
      setSyncMatches(_syncMatches);
      setControlMatches(await _controlMatches(_syncMatches, _todaysMatchs));
    } catch (e) {
      toast.error('Error fetching matches');
    }
  };
  const handleEnablePush = async (matchId, newState) => {
    try {
      await api.clubadmin.match.admin.updatePushSetting(matchId, newState);
      fetch();
    } catch (e) {
      toast.error('Error enabling push');
    }
  };
  const renderMatches = (matches, warningLevel) =>
    matches.map((match) => (
      <tr key={match.id}>
        <td>{match.id}</td>
        <td>{match.matchStart}</td>
        <td>{`${match?.homeTeam?.name} - ${match?.awayTeam?.name}`}</td>
        <td>{match.league?.name || ''}</td>
        <td>{match.league?.id || ''}</td>
        <td>
          {' '}
          <CheckIcon state={match.pushEnabled} />
        </td>
        <td>
          <div
            style={{ width: 40, height: 40, backgroundColor: warningLevel }}
          />
        </td>
        <td>
          <UncontrolledDropdown className="dashboard__table-more">
            <DropdownToggle>
              <DotsHorizontalIcon />
            </DropdownToggle>
            <DropdownMenu className="dropdown__menu">
              <DropdownItem
                onClick={() => handleEnablePush(match.id, !match.pushEnabled)}
              >
                {match.pushEnabled ? 'Disable push' : 'Enable push'}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));

  const syncDailies = async () => {
    try {
      await api.clubadmin.leagues.syncDailies();
    } catch (e) {
      toast.error('Error syncing dailies');
    } finally {
      setTimeout(async () => {
        await fetch();
      }, 5000);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <>
      <div className="flex space-between" style={{ float: 'right' }}>
        <Button color="info" onClick={syncDailies}>
          Run Sync dailies
        </Button>
      </div>
      <Table responsive bordered>
        <thead>
          <tr>
            <th>Match Id</th>
            <th>Match start</th>
            <th>Match name</th>
            <th>League</th>
            <th>League Id</th>
            <th>Push enabled</th>
            <th>Warning level</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {renderMatches(controlMatches.red, 'red')}
          {renderMatches(controlMatches.green, 'green')}
          {renderMatches(controlMatches.yellow, 'yellow')}
        </tbody>
      </Table>
    </>
  );
};

export default SyncMatchControl;
